'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsFormat = require('@bibliocommons/utils-format');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormatIndicator = function (_BcReactComponent) {
  _inherits(FormatIndicator, _BcReactComponent);

  function FormatIndicator() {
    _classCallCheck(this, FormatIndicator);

    return _possibleConstructorReturn(this, (FormatIndicator.__proto__ || Object.getPrototypeOf(FormatIndicator)).apply(this, arguments));
  }

  _createClass(FormatIndicator, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { className: 'cp-format-indicator', 'data-test-id': 'format-indicator' },
        _react2.default.createElement('span', { className: (0, _utilsFormat.getIconForFormat)(this.props.format), 'aria-hidden': true }),
        '\xA0',
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'FORMAT.' + this.props.format.toLowerCase() })
      );
    }
  }]);

  return FormatIndicator;
}(_baseBcReactComponent2.default);

FormatIndicator.propTypes = {
  format: _react2.default.PropTypes.string
};

exports.default = FormatIndicator;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-indicator/lib/components/FormatIndicator.component.js
// module id = 1205
// module chunks = 0